import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
const layers = [{
  title: 'Experience Layer',
  description: 'Chat/Voice Interfaces, In-App Copilots, and Agentic UIs',
  icon: '💬',
  highlighted: false
}, {
  title: 'Orchestration Layer',
  description: 'Tool Calling, Workflow Engines, RPA/IPA Integration',
  icon: '⚙️',
  highlighted: false
}, {
  title: 'Model Layer',
  description: 'Leading foundation models (OpenAI GPT, Google Gemini, open-source) + fine-tuned tasks, safety filters & evaluators',
  icon: '🧠',
  highlighted: true
}, {
  title: 'Data & Decision Layer',
  description: 'Connectors to Data Lake/Warehouse, Retrieval & Feature Stores',
  icon: '📊',
  highlighted: false
}];
export function ArchitectureSection() {
  return <section id="technology" className="py-24 bg-gradient-to-b from-slate-50 to-white" data-id="element-1">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <h2 className="section-title" data-id="element-3">Our Enterprise-Grade Architecture</h2>
        <p className="section-subtitle" data-id="element-4">
          A modern, scalable, and secure architecture with clear separation of
          concerns for robust integration and governance.
        </p>

        <div className="mt-16 relative" data-id="element-5">
          {/* Architecture Stack */}
          <div className="space-y-6" data-id="element-6">
            {layers.map((layer, index) => <div key={layer.title} data-id="element-7">
                <div className={`relative overflow-hidden transition-all duration-200 hover:scale-[1.02] ${layer.highlighted ? 'bg-gradient-to-r from-blue-50 to-blue-100 border-2 border-blue-300 shadow-lg' : 'bg-white border-2 border-slate-200 shadow-md hover:shadow-lg'} rounded-xl p-6`} data-id="element-8">
                  <div className="flex items-start gap-4" data-id="element-9">
                    <div className="text-4xl flex-shrink-0" data-id="element-10">{layer.icon}</div>
                    <div className="flex-1" data-id="element-11">
                      <h4 className={`text-xl font-bold mb-2 ${layer.highlighted ? 'text-blue-900' : 'text-slate-900'}`} data-id="element-12">
                        {layer.title}
                      </h4>
                      <p className={`text-sm leading-relaxed ${layer.highlighted ? 'text-blue-800' : 'text-slate-600'}`} data-id="element-13">
                        {layer.description}
                      </p>
                    </div>
                  </div>
                  {layer.highlighted && <div className="absolute top-3 right-3 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-14">
                      CORE
                    </div>}
                </div>

                {/* Arrow between layers */}
                {index < layers.length - 1 && <div className="flex justify-center py-2" data-id="element-15">
                    <ArrowDownIcon className="w-8 h-8 text-blue-600 animate-pulse" strokeWidth={3} data-id="element-16" />
                  </div>}
              </div>)}
          </div>

          {/* Governance Layer - Spans All */}
          <div className="mt-8 relative" data-id="element-17">
            <div className="absolute inset-x-0 top-1/2 h-0.5 bg-gradient-to-r from-transparent via-slate-300 to-transparent" data-id="element-18"></div>
            <div className="relative bg-gradient-to-r from-slate-100 to-slate-50 border-2 border-slate-300 rounded-xl p-6 shadow-xl" data-id="element-19">
              <div className="flex items-center justify-center gap-3 mb-3" data-id="element-20">
                <span className="text-3xl" data-id="element-21">🔒</span>
                <h4 className="text-xl font-bold text-slate-900" data-id="element-22">
                  Governance & Security (Cross-Cutting)
                </h4>
              </div>
              <p className="text-center text-slate-600 text-sm" data-id="element-23">
                Access Control • Audit Logging • Prompt/Model Versioning • Cost
                Monitoring • Compliance
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}